import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import BottomNav from './components/BottomNav';
import Dashboard from './pages/Dashboard';
import CalendarView from './pages/CalendarView';
import Trends from './pages/Trends';
import ExportPage from './pages/ExportPage';
import Settings from './pages/Settings';
import LogWizard from './pages/LogWizard';

function AppContent() {
  const location = useLocation();
  const isLogPage = location.pathname === '/log';

  return (
    <div className="app">
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/calendar" element={<CalendarView />} />
        <Route path="/trends" element={<Trends />} />
        <Route path="/export" element={<ExportPage />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/log" element={<LogWizard />} />
      </Routes>
      {!isLogPage && <BottomNav />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
